// const host = 'https://auto.caiyuemedical.com/zksrmyytest'//测试
const host = 'https://zsyy.zksrmyy.cn/zksrmyy' //正式
// const host = 'https://zsyy.zksrmyy.cn/zksrmyytest' //测试

const baseUrl = (process.env.NODE_ENV === 'development' ? host : host)

const API = {
  baseUrl: baseUrl,
  common: `${baseUrl}/api/wlpt/common`,
  appointDoctor: `${baseUrl}/api/wlpt/appoint`, //post 确认预约
  getRecordList: `${baseUrl}/api/wlpt/reisterList`, // get 获取预约挂号列表
  getDaysRecordList: `${baseUrl}/api/register/record`, // get 获取当日挂号列表
  cancelReister: `${baseUrl}/api/wlpt/cancelReister`, // post 退号
  getJSAPIsign: `${baseUrl}/api/wechat/getJsapiTicket`, // get 获取微信jsapi权限


  // 周口
  code2openidwx: `${baseUrl}/api/wechat/code2openid`, // get 换取 wx openid
  code2openidali: `${baseUrl}/api/alipay/getAliUserId`, // get 换取 ali userid
  addUser: `${baseUrl}/api/user/addUser`, // 添加就诊人
  untieUser: `${baseUrl}/api/user/untieUser`, //就诊人解绑
  userList: `${baseUrl}/api/user/userList`, //GET 获取就诊人列表
  setDefaultUser: `${baseUrl}/api/user/setDefaultUser`, //设置默认就诊人
  getPatientInfo: `${baseUrl}/api/outpatient/getPatientInfo`, // 就诊人查询his
  getDeptSummary: `${baseUrl}/api/outpatient/getDeptSummary`, // 获取科室信息
  getScheNum: `${baseUrl}/api/outpatient/getScheNum`, // 获取医生号源信息
  appointRegister: `${baseUrl}/api/register/appointRegister`, //挂号
  registerPay: `${baseUrl}/api/register/registerPay`, //挂号支付
  regCardPay: `${baseUrl}/api/register/regCardPay`, //挂号就诊卡支付
  pushOutPatientInfo: `${baseUrl}/api/outpatient/pushOutPatientInfo`, // 挂号记录
  getAppointRegister: `${baseUrl}/api/register/getAppointRegister`, // 未支付的挂号记录

  recharge: `${baseUrl}/api/user/recharge`, // 就诊卡充值

  getAccountInfo: `${baseUrl}/api/outpatient/getAccountInfo`, // 卡余额

  payNormalOrder: `${baseUrl}/api/diag/payNormalOrder`, // 门诊缴费微信支付
  payCardOrder: `${baseUrl}/api/diag/payCardOrder`, // post 缴费-缴费（就诊卡支付）

  getPresc: `${baseUrl}/api/outpatient/getPresc`, // 门诊待缴费列表
  getPrescDetail: `${baseUrl}/api/outpatient/getPrescDetail`, // 门诊待缴费明细
  getOutPatientCharge: `${baseUrl}/api/outpatient/getOutPatientCharge`, // 门诊消费查询
  getOutPatientChargeList: `${baseUrl}/api/outpatient/getOutPatientChargeList`, // 门诊消费明细查询

  getInpiPatientinfo: `${baseUrl}/api/outpatient/getInpiPatientinfo`, // 住院信息
  getBill: `${baseUrl}/api/outpatient/getBill`, // 门诊充值记录查询
  getFeeListInPat: `${baseUrl}/api/outpatient/getFeeListInPat`, // 住院日清单

  hospitalizationPay: `${baseUrl}/api/hospitalization/hospitalizationPay`, // 住院充值
  depositRecharge: `${baseUrl}/api/inHospital/depositRecharge`, //post 住院充值===========
  getRechargeRecord: `${baseUrl}/api/outpatient/getRechargeRecord`, // 住院充值记录查询

  getRisReportInfo: `${baseUrl}/api/outpatient/getRisReportInfo`, // 检查报告查询
  getLisReportInfo: `${baseUrl}/api/outpatient/getLisReportInfo`, // 检验报告查询
  getLisDetailedInfo: `${baseUrl}/api/outpatient/getLisDetailedInfo`, // 检验报告明细查询

  dictList: `${baseUrl}/api/v2/dict/dictList`, // get 查询配置

  // 医保
  getWXMedicalAuth: `${baseUrl}/api/medicalInsurance/getWXMedicalAuth`, // 获取医保授权码的
  createOrder: `${baseUrl}/api/medicalInsurance/createOrder`, // 创建医保订单(预结算)
  payBigOrder: `${baseUrl}/api/diag/payBigOrder`, // post 诊间医保调起支付

  payNormalYbOrder: `${baseUrl}/api/diag/payNormalYbOrder`, // post 诊间医保调起支付

  // 出院结算
  preInPatientSettle: `${baseUrl}/api/v2/inHospital/preInPatientSettle`, // post 出院预结算
  settlementOrderPay: `${baseUrl}/api/settlementOrder/settlementOrderPay`, //调起支付 orderNo
  inPatientSettle: `${baseUrl}/api/v2/inHospital/inPatientSettle`, //post 出院结算
  getRefundPrepay: `${baseUrl}/api/v2/inHospital/getRefundPrepay`, //get 已结算详情

  // 周口





  // 九院的api
  // ------------------微信健康卡---------------------
  registerHealthCard: `${baseUrl}/api/healthcard/registerHealthCard`, //POST 注册微信电子健康卡
  ocrInfo: `${baseUrl}/api/healthcard/ocrInfo`, //POST 身份证OCR接口
  getOrderIdByOutAppId: `${baseUrl}/api/healthcard/getOrderIdByOutAppId`, //POST 获取卡包订单id
  healthCardList: `${baseUrl}/api/healthcard/healthCardList`, //POST 获取已绑定健康卡
  unbingHealthCard: `${baseUrl}/api/healthcard/unbingHealthCard`, //POST 解绑健康卡
  getHealthCardByHealthCode: `${baseUrl}/api/healthcard/getHealthCardByHealthCode`, //POST 健康卡授权码获取健康卡
  bindHealthCard: `${baseUrl}/api/healthcard/bindHealthCard`, //POST 绑定健康卡与院内id
  userDetail: `${baseUrl}/api/user/userDetail`, // get *就诊人详情
  //-----我的就诊人---------
  getPatientByIdCard: `${baseUrl}/api/user/getUserInfo`, // post 根据身份证号查询建档信息 2
  bind: `${baseUrl}/api/wlpt/bind`, // post 绑卡or建档
  oldAddUser: `${baseUrl}/api/user/oldAddUser`, // post *完善就诊人信息
  medicalCardBind: `${baseUrl}/api/alipay/medicalCardBind`, //get 绑定医保卡
  addMedicalCard: `${baseUrl}/api/user/addMedicalCard`, //post 是否绑定医保卡
  encryptCardNo: `${baseUrl}/api/user/encryptCardNo`, //get 获取加密的二维码卡号
  getCardInfo: `${baseUrl}/api/user/getCardInfo`, //get 获取二维码内容或就诊人信息
  updateInfo: `${baseUrl}/api/user/getUpdateInfo`, //get 完善就诊人身份证号
  getMyChargeRecordList: `${baseUrl}/api/user/rechargeList`, //get 就诊卡充值记录列表
  getArchivePatients: `${baseUrl}/api/user/getArchivePatients`, //微信腾讯健康获取信息
  getInCardNo: `${baseUrl}/api/user/getInCardNo`, //修改默认就诊卡号
  getQueryMiCard: `${baseUrl}/api/user/getQueryMiCard`, //查询社保卡信息 get
  addCard: `${baseUrl}/api/user/addCard`, //关联社保卡 get
  getUserInfo: `${baseUrl}/api/user/userInfo`, //查询就诊卡信息 get
  addNoCard: `${baseUrl}/api/noCard/addNoCard`, //post 添加无卡预约信息
  getNoCard: `${baseUrl}/api/noCard/getNoCard`, //get 查询无卡预约患者信息
  getCardValue: `${baseUrl}/api/user/getCardValue`, //get 查询就诊卡（卡号、监护人身份证号、患者身份证号）

  //挂号
  getDeptInfoToDay: `${baseUrl}/api/register/getDeptInfoToDay`, // post 获取科室 1
  getDoctorToDay: `${baseUrl}/api/register/getDoctorToDay`, // post 获取医生 1
  addRegisterOrder: `${baseUrl}/api/register/wXAddRegisterOrder`, //post  确认挂号 1
  recordLocal: `${baseUrl}/api/register/recordLocal`, //post  自己后台查挂号记录 1

  searchDoctor: `${baseUrl}/api/register/getDoctorByName`, // get 搜索医生
  getDeptName: `${baseUrl}/api/register/getDeptName`, // get 获取关联科室
  getNum: `${baseUrl}/api/register/getNum`, // get 获取医生号源
  // registerPay: `${baseUrl}/api/register/registerPay`, //get 挂号支付(现金支付)
  record: `${baseUrl}/api/appoint/record`, // get 当日挂号记录列表
  getSearchDeptInfo: `${baseUrl}/api/register/getSearchDeptInfo`, // get 获取科室列表
  appointCancel: `${baseUrl}/api/register/appointCancel`, // get 取消预约
  regPayWX: `${baseUrl}/api/register/registerPay`, // get 挂号支付-微信
  regPayAli: `${baseUrl}/api/register/registerPay`, // get 挂号支付-支付宝

  //缴费
  payBigOrderAli: `${baseUrl}/api/alipay/medicalCardQuery`, //get 缴费-支付宝查询是否绑定医保卡
  getCompletedPayList: `${baseUrl}/api/diag/getCompletedPayList`, //post 缴费-用户已缴费记录查询
  getCompletedPayDetails: `${baseUrl}/api/diag/getCompletedPayDetails`, // get 已缴费详情
  // medicalCardBind: `${baseUrl}/api/alipay/medicalCardBind`, //get 绑定医保卡
  payMent: `${baseUrl}/api/alipay/payment`, // post 缴费-缴费（支付宝支付）
  getPaybillfee: `${baseUrl}/api/diag/getPaybillfee`, //get 缴费-未交费明细门诊
  getPayInfo: `${baseUrl}/api/diag/getPayInfo`, // get 待缴费详情 1
  getDoPayInfo: `${baseUrl}/api/diag/paidInfo`, // get 已缴费记录 1 门诊

  pendingPayment: `${baseUrl}/api/diag/pendingPayment`, // post 已缴费记录 2
  // payBigOrder: `${baseUrl}/api/diag/payBigOrder`, // post 缴费-缴费（微信医保支付）

  cardBalance: `${baseUrl}/api/user/cardTotalAmount`, // get 就诊卡余额
  diagPay: `${baseUrl}/api/diag/confirmPayment`, // post 诊间支付 1
  diagToPay: `${baseUrl}/api/diag/diagToPay`, // post 门诊支付 1

  //检验
  getExamineList: `${baseUrl}/api/diag/getExamineList`, //get 检验记录
  getExamDetail: `${baseUrl}/api/diag/getExamDetail`, //get 检验明细
  // 检查
  getCheckList: `${baseUrl}/api/diag/getCheckList`, //get 检查记录
  getExamineDetail: `${baseUrl}/api/diag/getExamDetail`, //get 检查明细

  //住院
  getHospitalPayment: `${baseUrl}/api/inpatient/getHospitalPayment`, //post 住院消费清单========
  getHospitalDeposit: `${baseUrl}/api/inpatient/getHospitalDeposit`, //post 住院押金清单========
  getPatInfo: `${baseUrl}/api/inpatient/getPatInfo`, //get 获取住院患者信息================


  depositPayment: `${baseUrl}/api/alipay/depositPayment`, //post 支付宝住院押金充值
  fapiaoList: `${baseUrl}/api/inHospital/ZYFPInfoList`, //get 发票列表，获取一日清单金额信息
  dayBillList: `${baseUrl}/api/inHospital/dayBillList`, //get 一日清单列表
  dayBill: `${baseUrl}/api/inHospital/dayBill`, //get 一日清单
  dayBillDetail: `${baseUrl}/api/inHospital/dayBillDateils`, //get 一日清单
  getMyHisChargeRecordList: `${baseUrl}/api/inHospital/depositRechargeList`, //get 住院押金记录
  getMyHisChargeRecordDetail: `${baseUrl}/api/inHospital/depositRechargeDetails`, //get 住院押金记录
  getWindNoAndPypc: `${baseUrl}/api/diag/getWindNoAndPypc`, //get 配药批次和窗口号
  getZhuYuanRecordList: `${baseUrl}/api/inHospital/getZhuYuanRecordList`, //get 住院结算列表
  getZhuYuanRecordDetail: `${baseUrl}/api/inHospital/getZhuYuanRecordDetail`, //get 住院结算列表详情
  getZhuYuanFee: `${baseUrl}/api/inHospital/zxZhuYuanFee`, //get 住院结算
  inHospitalPay: `${baseUrl}/api/wlpt/inHospitalPay`, //post 住院充值 -- 没用

  //医院
  getDeptInfo: `${baseUrl}/api/register/getDeptInfo`, //get 科室信息
  getDoctorInfo: `${baseUrl}/api/register/getDoctorInfo`, //get 医生信息
  getHospitalIntro: `${baseUrl}/api/register/hospitalIntroduction`, //get 医院介绍
  commitComment: `${baseUrl}/api/register/proposeBack`, //get 建议反馈

  //关注
  getAttentionList: `${baseUrl}/api/atten/attentionList`, //get 关注列表
  delAttention: `${baseUrl}/api/atten/deleteAttention`, //get 取消关注
  addAttention: `${baseUrl}/api/atten/addAttention`, //get 添加关注

  //健康百科
  getArticleList: `${baseUrl}/api/article/getArticleList`, //get 健康百科列表
  getArticleDetails: `${baseUrl}/api/article/getArticleDetails`, //get 健康百科详情

  //自助开单
  getMenuList: `${baseUrl}/api/diag/getMenuList`, //get 套餐列表
  wxMenuPay: `${baseUrl}/api/diag/wxMenuPay`, //get 支付
  queryMenuRecord: `${baseUrl}/api/diag/queryMenuRecord`, //get 开单记录
  addSurvey: `${baseUrl}/api/survey/addSurvey`, //  post 提交核酸问卷问题

  // 高德获取行政区域
  getDistByGD: `https://restapi.amap.com/v3/config/district`, //get

  //2021-06-10 预约及当日 接口 new
  getNumNew: `${baseUrl}/api/register/A105`, //get 查询排班科室 2
  getHospitalList: `${baseUrl}/api/register/getHospitalList`, //get 查询排班科室 2
  queryDoctorListNew: `${baseUrl}/api/register/doctorList`, //get 查询医生列表：2
  querySourceListNew: `${baseUrl}/api/register/A107`, //get 医生排班 2
  qourceList: `${baseUrl}/api/register/A108`, //get 医生排班 2
  appointmentBySource: `${baseUrl}/api/register/register`, //get 预约挂号 2
  cancelAppointmentByCode: `${baseUrl}/api/register/cancelRegOrder`, //get 取消预约 2
  queryAppointmentByIdNumber: `${baseUrl}/api/v2/appoint/queryAppointmentByIdNumber`, //get 根据身份证号查询预约信息
  queryAppointmentByCode: `${baseUrl}/api/v2/appoint/queryAppointmentByCode`, //get 没用到 根据预约码查询预约信息
  signAppointmentByCode: `${baseUrl}/api/v2/appoint/signAppointmentByCode`, //get 签到 没用到
  registeredNumberLock: `${baseUrl}/api/v2/appoint/registeredNumberLock`, //get 挂号锁号 没用到
  medicalCardPayment: `${baseUrl}/api/v2/appoint/medicalCardPayment`, //post挂号支付发起
  registeredRecord: `${baseUrl}/api/register/registerListByLocal`, //post挂号记录

  // 发票
  outpatientInvoice: `${baseUrl}/api/diag/outpatientInvoice`, //post 门诊发票
  hospitalInvoice: `${baseUrl}/api/inpatient/hospitalInvoice`, //post 住院发票

  //  预约疫苗
  vaccineUserAdd: `${baseUrl}/api/vaccineUser/addUser`, //post 添加接种人
  vaccineUpdateUser: `${baseUrl}/api/vaccineUser/updateUser`, //修改接种人
  vaccineUserList: `${baseUrl}/api/vaccineUser/userList`, //post 接种人列表
  vaccineSetDefaultUser: `${baseUrl}/api/vaccineUser/setDefaultUser`, //post 设置默认接种人
  getVaccineList: `${baseUrl}/api/vaccine/getVaccineList`, //post 疫苗类型
  numberSourceList: `${baseUrl}/api/vaccine/numberSourceList`, //post 号源列表
  insertVaccineOrder: `${baseUrl}/api/vaccine/insertVaccineOrder`, //post 预约疫苗
  vaccineOrderList: `${baseUrl}/api/vaccine/vaccineOrderList`, //post 预约列表
  vaccineCancel: `${baseUrl}/api/vaccine/cancel`, //post 取消预约疫苗


  //医保
  ybPaySwitch: `${baseUrl}/api/article/switch?key=medical_insurance_switch_wechat`, //get 医保开关
  medicalAuthinfoAuthQuery: `${baseUrl}/api/medicalInsurance/weixinCommerceMedicalAuthinfoAuthQuery`, //post 获取医保授权码
  createYbOrder: `${baseUrl}/api/medicalInsurance/healthInsuranceOrder`, //post 创建医保订单
  medicalInsuranceToPay: `${baseUrl}/api/medicalInsurance/medicalInsuranceToPay_WX`, //post 医保下单

  //PDF下载
  downloadJyJcPdf: `${baseUrl}/api/diag/downloadPdf`, //get 检验pdf下载


  //医技预约
  getApplyOrderList: `${baseUrl}/api/medicalAppointment/getCommonApplyOrderList`, //获取医嘱单信息
  getFourDimensionalSource: `${baseUrl}/api/medicalAppointment/getFourDimensionalSource`, //获取号源列表
  bcApply: `${baseUrl}/api/medicalAppointment/bcApply`, //预约提交
}

export default API



// WEBPACK FOOTER //
// ./src/js/api.js